module.exports = __webpack_public_path__ + "media/images/metronic/loading-spinner-default-1847ea9f2247906fe7f888137486b70b.gif";